import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../app/hooks';
import { getValueFromResource, setItemStatus } from '../../../common/timeLiveFunction';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';
import clsx from 'clsx';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { Navigate, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';

type CheckStatus = 'idle' | 'loading' | 'success' | 'failed';

const BiometricConfigurationList = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [biometricList, setBiometricList] = useState<any[]>([]);
    const [checkStatusMap, setCheckStatusMap] = useState<{ [key: number]: CheckStatus }>({});

    const getBiometricConfigurationList = async () => {
        try {
            const response = await fetchTimeliveAPI("api/BiometricConfiguration", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            setBiometricList(json?.Data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getBiometricConfigurationList();
    }, [])

    const deleteDevice = async (biometricDeviceId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then(async (result) => {
                if (result) {
                    try {
                        const response = await fetchTimeliveAPI(`api/BiometricConfiguration/DeleteAccountBiometricConfiguration/${biometricDeviceId}`, `DELETE`, '', true);
                        const json = await response.json();
                        if (json?.StatusCode === '200') {
                            getBiometricConfigurationList();
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading d-flex align-items-center gap-1">
                        {getValueFromResource('Biometric Device Detail', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center gap-2">
                        <a
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="dashboard-tooltip"
                            data-tooltip-content={getValueFromResource("Refresh All", dispatch, t)}
                            data-tooltip-place="bottom"
                            onClick={getBiometricConfigurationList}
                        >
                            <i className="bi bi-arrow-repeat fs-3 iconColor"></i>
                        </a>
                        <div className="bullet bg-secondary h-35px w-1px mx-2"></div>
                        <button
                            type="submit"
                            className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                            onClick={() => navigate('/BiometericDeviceConfiguration')}
                        >
                            Add Device
                        </button>
                    </div>
                </div>
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <table className="table table-row-bordered align-middle gs-1 gy-1 gx-1">
                            <thead>
                                <tr className="thHeading align-middle">
                                    <th style={{ width: '15%' }}>{getValueFromResource('Active / Inactive', dispatch, t)}</th>
                                    <th style={{ width: '25%' }}>{getValueFromResource('Device Name', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('Serial Number', dispatch, t)}</th>
                                    <th style={{ width: '15%' }}>{getValueFromResource('Device IP', dispatch, t)}</th>
                                    <th style={{ width: '10%' }}>{getValueFromResource('Port', dispatch, t)}</th>
                                    <th style={{ width: '10%' }}>{getValueFromResource('Status', dispatch, t)}</th>
                                    <th className='w-10 text-center'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {biometricList?.length > 0 && biometricList?.map((item: any) => {
                                    const status = checkStatusMap[item.BiometricDeviceId] || 'idle';

                                    return (
                                        <tr key={item.BiometricDeviceId}>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsActive ? "Active" : "InActive"))}>
                                                    {item.IsActive ? "Active" : "InActive"}
                                                </span>
                                            </td>
                                            <td className='text-gray-800 text-hover-primary custom-pointer-cursor'>
                                                <span onClick={() => navigate(`/biometericDeviceConfiguration/${item.BiometricDeviceId}`)} className="d-block">{item?.DeviceName}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block">{item?.DeviceIdentifier}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block">{item?.DeviceIPAddress}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                <span className="d-block">{item?.DevicePort}</span>
                                            </td>
                                            <td className='text-gray-800'>
                                                {/* <span className="d-block">{item?.Status}</span> */}
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.Status ? "Success" : "Fail"))}>
                                                    {item.Status ? "Online" : "Offline"}
                                                </span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7"></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => {
                                                                    navigate(`/biometericDeviceConfiguration/${item.BiometricDeviceId}`)
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        {/* <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => deleteDevice(item?.BiometricDeviceId)}
                                                            >
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {getValueFromResource('Delete', dispatch, t)}

                                                                </span>
                                                            </Dropdown.Item>
                                                        </div> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default BiometricConfigurationList